/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Upper_Thrush_FlowInputs */

const es_new_upper_thrush_flow = /** @type {(inputs: New_Upper_Thrush_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const gl_new_upper_thrush_flow = /** @type {(inputs: New_Upper_Thrush_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const en_new_upper_thrush_flow = /** @type {(inputs: New_Upper_Thrush_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {New_Upper_Thrush_FlowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const new_upper_thrush_flow = /** @type {((inputs?: New_Upper_Thrush_FlowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Upper_Thrush_FlowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_new_upper_thrush_flow(inputs)
	if (locale === "en") return en_new_upper_thrush_flow(inputs)
	return es_new_upper_thrush_flow(inputs)
});